import { render } from "./B2bFilterButtonOcrDocuments.vue?vue&type=template&id=a58710d2&scoped=true&lang=pug"
import script from "./B2bFilterButtonOcrDocuments.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonOcrDocuments.vue?vue&type=script&lang=js"

import "./B2bFilterButtonOcrDocuments.vue?vue&type=style&index=0&id=a58710d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a58710d2"]])

export default __exports__